import React from 'react';
import PropTypes from 'prop-types';
import { useDataTable } from '../../hooks/useDataTable';

const EmpresasTable = ({ empresas, onRowClick, showCreateButton, onCreateClick }) => {
  const columns = React.useMemo(() => [
    {
      Header: 'Sigla',
      accessor: 'sigla',
    },
    {
      Header: 'Razón Social',
      accessor: 'razonSocial',
    },
    {
      Header: 'Jefe Flota',
      accessor: 'jefeFlota',
    },
    {
      Header: 'Teléfono',
      accessor: 'telefonoComercial',
    },
    {
      Header: '$ Día Siguiente',
      accessor: row => {
        const precio = row.precio_empresa?.find(
          p => p.servicio_spread?.servicio === 'DIA SIGUIENTE'
        );
        return precio ? `$${precio.precio}` : '-';
      },
      id: 'diaSiguiente',
    },
    {
      Header: '$ Mismo Día',
      accessor: row => {
        const precio = row.precio_empresa?.find(
          p => p.servicio_spread?.servicio === 'MISMO DIA'
        );
        return precio ? `$${precio.precio}` : '-';
      },
      id: 'mismoDia',
    },
  ], []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    pageIndex,
    pageSize,
    setPageSize,
    setGlobalFilter,
    globalFilter,
  } = useDataTable({ columns, data: empresas, initialPageSize: 10 });

  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      {/* Fila superior: búsqueda y botón crear */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <input
          type="text"
          className="form-control form-control-sm"
          style={{ maxWidth: 300 }}
          placeholder="Buscar empresa..."
          value={globalFilter || ''}
          onChange={e => setGlobalFilter(e.target.value)}
        />
        {showCreateButton && (
          <button className="btn btn-primary btn-sm" onClick={onCreateClick}>
            + Crear Empresa
          </button>
        )}
      </div>
      <table {...getTableProps()} className="table table-hover" style={{ minWidth: '600px' }}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map(row => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                style={{ cursor: 'pointer' }}
                onClick={() => onRowClick(row.original)}
              >
                {row.cells.map(cell => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {/* Paginación mejorada */}
      <div className="d-flex justify-content-between align-items-center mt-2">
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          >
            {'<<'}
          </button>
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            {'<'}
          </button>
          <span style={{ minWidth: 90, textAlign: 'center' }}>
            Página <strong>{pageIndex + 1}</strong> de <strong>{pageOptions.length}</strong>
          </span>
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            {'>'}
          </button>
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            {'>>'}
          </button>
        </div>
        <div className="d-flex align-items-center gap-2">
          <span className="me-2">
            Total registros: <strong>{empresas.length}</strong>
          </span>
          <select
            value={pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
            className="form-select form-select-sm"
            style={{ width: 'auto', display: 'inline-block' }}
          >
            {[10, 20, 30, 40, 50].map(size => (
              <option key={size} value={size}>
                Mostrar {size}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

EmpresasTable.propTypes = {
  empresas: PropTypes.array.isRequired,
  onRowClick: PropTypes.func.isRequired,
  showCreateButton: PropTypes.bool,
  onCreateClick: PropTypes.func,
};

export default EmpresasTable;
